import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    ProTableOt,
    Input,
    useProTableOt,
    Accordion, AccordionItem, AccordionTrigger, AccordionContent,
    setParamsFilter,
    AspectRatio,
    Form
} from "../../ui/ot";
import axios from "axios";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs"
import { Avatar, AvatarFallback, AvatarImage } from "../../ui/avatar"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/card'
import { Book, Clock, History, Download } from "lucide-react"
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import useWindowSize from '../../online_public_catalog_query_construction/controllers/window_size';
import PasswordChangeForm from "./password_change_form";
import { useTranslation } from "react-i18next";
import BindLineId from "../../login/BindLineId";

const userData = {
    id: "12345",
    name: "王小明",
    email: "wang@example.com",
    barcode: "2023112500001",
    memberSince: "2020-05-15",
    checkOutTotal: 3,
    holdTotal: 1,
    profileImage: "/placeholder.svg?height=100&width=100",
}

const PersonalInfoQuery = ({
    keyPrefix = "library.personal_info_query",

}) => {
    const actionRef = useRef();
    const [form] = Form.useForm();
    const [staffData, setStaffData] = useState(null)
    const [extra_columns, set_extra_columns] = useState([]);
    const [showMode, setShowMode] = useState("cardPage")
    const columns = [
        {
            title: 'ISBN',
            dataIndex: 'bibitem_isbn',
            key: 'bibitem_isbn',
            sorter: false,
        },
        {
            title: '書名',
            dataIndex: 'best_title',
            key: 'best_title',
            width: "20rem",
            render: (text, record, index) => {
                return (record?.bib_title || "") + (record?.bib_subtitle || "") 
            }
        },
        {
            title: '歸還日期',
            dataIndex: 'checkout_due_datetime',
            key: 'checkout_due_datetime',
            sorter: false,

        },
        {
            title: '續借次數',
            dataIndex: 'checkout_due_datetime',
            key: 'checkout_due_datetime',
            sorter: false,

        },
        {
            title: '逾期歸還天數',
            dataIndex: 'checkout_due_datetime',
            key: 'checkout_due_datetime',
            sorter: false,

        }
    ];
    const { width, height } = useWindowSize();
    const { t } = useTranslation('translation', { keyPrefix })

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "patch") {
                message.success(t('modify_success'));
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
            }
        } else if (status === "error") {
            if (axiosMode === "patch") {
                message.error(t('modify_failure'));
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
            }
        }
    };
    const userChangePasswordController = useCRUDController({
        apiRoute: "/library/user/password",
        onFinish
    })
    const userCheckoutHistoryController = useCRUDController({
        apiRoute: "/koha/checkout/history"
    })
    const userHoldController = useCRUDController({
        apiRoute: "/koha/hold"
    })
    const userCheckoutController = useCRUDController({
        apiRoute: "/koha/checkout"
    })
    const staffController = useCRUDController({
        apiRoute: "/library/organization_structure/api/staff/concatenation_self"
    })
    const borrowerBarcodeImgController = useCRUDController({
        apiRoute: "/koha/borrower/barcode"
    })

    const {
        ResponseData: UserSelfData,
        getData: getUserSelfData,
        patchData: patchUserSelfData
    } = useCRUDController({
        apiRoute: '/home/user_self',
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    useEffect(() => {
        if (width <= 430) {
            setShowMode('card')
        }
        else {
            setShowMode('cardPage')
        }
    }, [width])
    useEffect(() => {
        if (!!actionRef.current) {
            if (showMode === "card") {
                actionRef.current.reloadAndRest()
            }
            else {
                actionRef.current.reload()
            }
        }

    }, [showMode])


    useEffect(() => {
        staffController.getData({})
            .then((response) => {
                let data = response?.data || []
                let firstData = data.find((ele) => true)
                setStaffData((pre) => {
                    return {
                        ...pre,
                        ...firstData
                    }
                })
                borrowerBarcodeImgController.getData({
                    borrowernumber: firstData?.borrowernumber
                })

            })
        getUserSelfData({})
    }, [])
    useEffect(() => {

        if (staffData?.borrowernumber) {
            userCheckoutController.getData({
                borrowernumber: staffData?.borrowernumber
            }).then((response) => {
                let total = response?.total || 0


                setStaffData((pre) => {
                    return {
                        ...pre,
                        checkOutTotal: total
                    }
                })

            })
            userHoldController.getData({
                borrowernumber: staffData?.borrowernumber
            }).then((response) => {
                let total = response?.total || 0


                setStaffData((pre) => {
                    return {
                        ...pre,
                        holdTotal: total
                    }
                })

            })
        }
    }, [staffData?.borrowernumber])

    return (<Row gutter={[32, 32]}>
        <Col span={24}>
        </Col>
        <Col span={24} className="min-h-full" >
            <Row gutter={[32, 32]} >
                <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24} className="min-h-full" >
                    <Card

                        className="md:col-span-1 shadow-lg border-primary/20  min-h-max" >
                        <CardHeader className="bg-primary/10 rounded-t-lg">
                            <div className="flex flex-col items-center space-y-4">
                                <Avatar className="h-24 w-24 ring-2 ring-primary/20">
                                    <AvatarImage src={userData.profileImage} alt={staffData?.staff_name} />
                                    <AvatarFallback className="bg-secondary text-secondary-foreground">
                                        {staffData?.staff_name}
                                    </AvatarFallback>
                                </Avatar>
                                <div className="text-center">
                                    <CardTitle className="text-primary">{staffData?.staff_name}</CardTitle>
                                    <CardDescription>{staffData?.email}</CardDescription>
                                </div>
                            </div>
                        </CardHeader>
                        <CardContent className="mt-4 ">
                            <div className="space-y-4">
                                <div className="flex flex-col items-center space-y-3 p-3 border border-primary/20 rounded-lg bg-primary/5">
                                    <p className="text-sm font-medium text-primary">{t('personal_barcode')}</p>
                                    {/* <svg ref={barcodeRef} className="w-full"></svg> */}
                                    <img src={borrowerBarcodeImgController?.ResponseData}></img>
                                    {/* <Button
                                        variant="outline"
                                        size="sm"
                                        className="flex items-center gap-1 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                                    onClick={downloadBarcode}
                                    >
                                        <Download className="h-4 w-4" />
                                        <span>下載條碼</span>
                                    </Button> */}
                                </div>
                                <div className="grid grid-cols-2 gap-2 mt-6">
                                    <div className="flex flex-col items-center p-3 bg-primary/10 rounded-lg">
                                        <Book className="h-5 w-5 text-primary mb-1" />
                                        <span className="text-sm font-medium">{t('borrowing')}</span>
                                        <span className="text-xl font-bold text-primary">{staffData?.checkOutTotal || 0}</span>
                                    </div>
                                    <div className="flex flex-col items-center p-3 bg-secondary/10 rounded-lg">
                                        <Clock className="h-5 w-5 text-secondary mb-1" />
                                        <span className="text-sm font-medium">{t('reserving')}</span>
                                        <span className="text-xl font-bold text-secondary">{staffData?.holdTotal || 0}</span>
                                    </div>
                                </div>
                                <div className="pt-4">
                                    <Button
                                        block={true}
                                        variant="outline"
                                        className="w-full border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                                        onClick={() => {
                                            localStorage.removeItem('refresh_token');
                                            localStorage.removeItem('access_token');
                                            localStorage.removeItem('lineBind');
                                            axios.post('/logout').then(() => window.location.href = '/user_login').catch(console.error);
                                        }}
                                    >
                                        {t('logout')}
                                    </Button>
                                </div>
                                <div className="pt-4">
                                    <BindLineId
                                        userId={UserSelfData.find(_ => true)?.user_id}
                                    />
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </Col>
                <Col xxl={16} xl={16} lg={16} md={16} sm={24} xs={24} className="min-h-full">
                    <Card className="md:col-span-2 shadow-lg border-primary/20">
                        <Tabs defaultValue="profile" className="w-full">
                            <CardHeader className="bg-primary/10 rounded-t-lg">
                                <TabsList className="grid grid-cols-3 w-full bg-primary/20">
                                    <TabsTrigger
                                        value="profile"
                                        className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
                                    >
                                        個人資料
                                    </TabsTrigger>
                                    <TabsTrigger
                                        value="password"
                                        className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
                                    >
                                        密碼修改
                                    </TabsTrigger>
                                    <TabsTrigger
                                        value="history"
                                        className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
                                    >
                                        借閱歷史
                                    </TabsTrigger>
                                </TabsList>
                            </CardHeader>
                            <CardContent className="mt-4">
                                <TabsContent value="profile">
                                    <div className="space-y-4">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div className="space-y-2">
                                                <p className="text-sm font-medium text-primary">{t('reader_name')}</p>
                                                <p>{staffData?.staff_name}</p>
                                            </div>
                                            <div className="space-y-2">
                                                <p className="text-sm font-medium text-primary">{t('reader_id')}</p>
                                                <p>{staffData?.staff_serial_name}</p>
                                            </div>
                                            <div className="space-y-2">
                                                <p className="text-sm font-medium text-primary">{t('branch_code')}</p>
                                                <p>{staffData?.branchcode}</p>
                                            </div>
                                            <div className="space-y-2">
                                                <p className="text-sm font-medium text-primary">{t('affiliated_branch')}</p>
                                                <p>{staffData?.branchname}</p>
                                            </div>
                                            <div className="space-y-2">
                                                <p className="text-sm font-medium text-primary">{t('email')}</p>
                                                <p>{staffData?.email || "-"}</p>
                                            </div>
                                            <div className="space-y-2">
                                                <p className="text-sm font-medium text-primary">{t('registration_date')}</p>
                                                <p>{staffData?.create_time}</p>
                                            </div>
                                        </div>
                                    </div>
                                </TabsContent>

                                <TabsContent value="password">
                                    <Row justify="center">
                                        <Col span={20}>
                                            <Row>
                                                <Col span={24}>
                                                    <PasswordChangeForm
                                                        propsForm={form}
                                                        onFormFinish={(value) => {
                                                            userChangePasswordController.patchData({
                                                                ...value,
                                                                borrowernumber: staffData?.borrowernumber
                                                            })
                                                        }}
                                                    />
                                                </Col>
                                                <Col span={24}>
                                                    <Row justify="end">
                                                        <Col>
                                                            <Button
                                                                onClick={() => {
                                                                    form.submit()
                                                                }}>
                                                                {t('confirm_edit')}
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>

                                        </Col>
                                    </Row>
                                </TabsContent>

                                <TabsContent value="history">
                                    <div className="space-y-4">
                                        <p className="text-muted-foreground"> {t('recent_borrowing_records')}</p>
                                        <Row>
                                            <Col span={24}>
                                                <ProTableOt
                                                    searchParams={{
                                                        borrowernumber: staffData?.borrowernumber
                                                    }}
                                                    actionRef={actionRef}
                                                    columns={columns}
                                                    showMode={showMode}
                                                    rowKey={'checkout_id'}
                                                    selections={{
                                                        // onChange: (index_, data_) => set_data(data_)
                                                    }}
                                                    toolBarRender={() => [
                                                    ]}
                                                    extra_columns={extra_columns}
                                                    set_extra_columns={set_extra_columns}
                                                    manage_columns={false}
                                                    request={async (params = {}, sort, filter) => {
                                                        let newParams = {
                                                            borrowernumber: staffData?.borrowernumber
                                                        };
                                                        let order = setOrders(sort)
                                                        newParams = {
                                                            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                                            ...newParams,
                                                            order,
                                                            size: params.pageSize,
                                                            cur_page: params.current,
                                                            custom_filter_value: params.keyword ?? "",
                                                            custom_filter_key: custom_filter_key,
                                                            // borrowernumber: staffData?.borrowernumber || 0
                                                        };
                                                        newParams = setParamsFilter({
                                                            ...newParams,
                                                        });
                                                        return userCheckoutHistoryController.getData(newParams)
                                                    }}

                                                    rowSelection={false}
                                                    scroll={{
                                                        x: "max-content"
                                                    }}
                                                    cardRender={(record) => {
                                                        return (
                                                            <Card  >
                                                                <Row gutter={[16, 16]}>
                                                                    <Col xxl={4} xl={4} lg={5} md={8} sm={10} xs={24}   >
                                                                        <Row justify={"center"}>
                                                                            <Col xxl={24} xl={24} lg={24} md={24} sm={16} xs={12} >
                                                                                <AspectRatio ratio={3 / 4}>
                                                                                    <img
                                                                                        src={"https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=" +
                                                                                            record?.bibitem_isbn} className=" h-full w-full rounded-md object-cover" />
                                                                                </AspectRatio>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col xxl={20} xl={20} lg={19} md={16} sm={14} xs={24}>
                                                                        <Row gutter={[8, 8]}>
                                                                            <Col span={24}>
                                                                                <Typography.Title level={4}>
                                                                                    {record?.bib_title}{record?.bib_subtitle} 
                                                                                </Typography.Title>
                                                                            </Col>
                                                                            <Col span={24}>
                                                                                <Typography.P  >
                                                                                    {t('borrow_date')} : {record?.issue_issuedate || '-'}
                                                                                </Typography.P>
                                                                                <Typography.P  >
                                                                                    {t('return_date')} : {record?.issue_date_due || 0}
                                                                                </Typography.P>
                                                                                <Typography.P  >
                                                                                    {t('renewal_count')}  : {record?.checkout_renewal_count || 0}
                                                                                </Typography.P>

                                                                            </Col>

                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </Card>
                                                        )
                                                    }}
                                                    cardModeSetting={{
                                                        columnsCount: showMode === "cardPage" ? 2 : 1,
                                                        singleRowHeight: 30,
                                                    }}

                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </TabsContent>
                            </CardContent>
                        </Tabs>
                    </Card>
                </Col>
            </Row>
        </Col>
    </Row>)
}
export default PersonalInfoQuery

